<template>
    <div>
        <form style="margin-top: 5%">
            <div class="form-group" style=";">
                <input v-model="nome" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nome do Serviço">
            </div>
            <div class="form-group" style=";">
                <textarea v-model="descricao" class="form-control" placeholder="Descricao do Serviço" rows="5" ></textarea>
            </div>
            <div class="alignLeft form-group">
                <label for="exampleFormControlSelect1">Categoria</label>
                <select class="form-control" id="exampleFormControlSelect1" v-model="categoriaSel">
                    <option v-for="categoria in categorias" :value="categoria.id">{{categoria.nome}}</option>
                </select>
            </div>
            <div class="alignLeft form-group">
                <div class="row">
                    <div class="col-sm-1"><label>Imagens</label></div>
                </div>
                <input multiple type="file" class="form-control-file" id="imagensInput">
            </div>
            <div v-if="imagens.length > 0" class="row">
                <div  v-for="(imagem, index) in imagens" class="col-sm-3 imgServico">
                    <a @click="imagens.splice(index, 1);"><i class="glyphicon glyphicon-remove"></i></a>
                    <img :src="imagem" alt="" style="width: 100%">
                </div>
            </div>
            <button @click="gravar" type="submit" class="btn btn-success" style="margin-right: 10px" v-show="nome && descricao && !gravando">Gravar</button>
            <button class="btn btn-success" style="margin-right: 10px" v-show="gravando" disabled><i class='fa fa-spinner fa-spin'></i>Gravando</button>
            <button @click="voltar" type="submit" class="btn btn-danger">Cancelar</button>
        </form>
    </div>
</template>
<script>
import firebase from 'firebase';
// var database = firebase.database();

export default {
    name: 'Novo Servico',
	data() {
		return {
            nome: '',
            descricao: '',
            editar: false,
            idServico: null,
            imagens: [],
            categorias: [],
            categoriaSel: null,
            gravando: false
		}
	},
	created() {
        this.getCategorias()
        if(this.$route.params.id) {
            this.editar = true;
            this.idServico = this.$route.params.id;
            firebase.database().ref('/produtos/' + this.idServico).once('value').then((snapshot) => {
                this.nome = (snapshot.val()).nome;
                this.descricao = (snapshot.val()).descricao;
                this.categoriaSel = (snapshot.val()).categoria.toString()
                this.imagens = (snapshot.val()).imagens
            });
        }
	},
	methods: {
        async gravar() {
            this.gravando = true
            var storageRef = firebase.storage().ref();
            var files = document.getElementById('imagensInput').files;
            
            console.log(files)
            for(let i = 0; i < files.length; i++) {
                let file = files[i];

                var img = 'imagem'+i;
                var nameImg = file.name;
                var mountainImagesRef = storageRef.child(nameImg);
                
                await mountainImagesRef.put(file).then(async (snapshot) => {
                    await snapshot.ref.getDownloadURL().then((downloadURL) => {
                        console.log('url img ==> ', downloadURL)
                        this.imagens.push(downloadURL);
                    });
                });
            }

            let tempo = 1000 * files.length;
            setTimeout(async () => {
                if(this.imagens.length == 0) this.imagens.push('https://firebasestorage.googleapis.com/v0/b/usinagem-saraiva.appspot.com/o/without-image.jpeg?alt=media&token=d5053e0e-0798-4da5-86be-dcc3fee0e4f2')
                if(!this.editar) {
                    var bd = firebase.database().ref('produtos/');
                    let proxId = 0
        
                    // percorre a tabela para ver qual o ultimo ID utilizado
                    // o AWAIT irá parar a execução do programa aqui até que esta função termine de ser executada
                    await bd.on('child_added', (data) => {
                    let ultimoId = parseInt(data.key);
                        proxId = ultimoId > proxId ? ultimoId : proxId
                    });
                    proxId++
        
                    // grava um novo cliente com o proximo ID disponivel
                    await firebase.database().ref('produtos/' + proxId).set({
                        nome: this.nome,
                        descricao: this.descricao,
                        categoria: this.categoriaSel,
                        imagens: this.imagens
                    });
                    this.voltar();
                } else {
                    await firebase.database().ref('produtos/' + this.idServico ).update({
                        nome: this.nome,
                        descricao: this.descricao,
                        categoria: this.categoriaSel,
                        imagens: this.imagens
                    });
                    this.voltar();
                }
            }, tempo)

        },
        voltar() {
            this.$router.go(-1)
        },
        getCategorias() {
            var cat = firebase.database().ref('categorias/')
			cat.on('child_added', (data) => {
                this.categorias.push({ nome: data.val().nome, id: data.key})
            });
        }
	}
}
</script>
<style scoped>
.alignLeft {
    text-align: left!important
}
.imgServico{
    padding: 2%;
}
</style>
